import { render } from "./PromptTestDashboard.vue?vue&type=template&id=21737625&scoped=true"
import script from "./PromptTestDashboard.vue?vue&type=script&lang=js"
export * from "./PromptTestDashboard.vue?vue&type=script&lang=js"

import "./PromptTestDashboard.vue?vue&type=style&index=0&id=21737625&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21737625"]])

export default __exports__